import React from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';

export default function Loading(servico){
    return(
        <div style={{ display:'flex',
            justifyContent:'center',
            alignItem:'center',
            overflowY:'hidden',
            cursor:'default' }}>
            <ProgressSpinner style={{
                width: '20vw',
                height: '20vh'
            }} strokeWidth="2" fill="#EEEEEE" animationDuration=".5s" />
        </div>);
}
